import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  appServiceRawObjectFields,
  updateExtIdForFieldInObjectType,
  updateForObjectType,
  updateObjectTypesMapping,
} from 'slices/appService.slice';
import { useAppDispatch } from 'slices/store';
import type { IObjectTypeField } from 'types/state.interface';
import { Radio, Select, Table, Typography } from '@timeedit/ui-components/antd';

type MappedFieldMappingType = {
  appName?: any;
  objectType?: any;
  objectTypeIdx?: any;
};

const MappedFieldMapping = ({
  appName,
  objectType,
  objectTypeIdx,
}: MappedFieldMappingType) => {
  const dispatch = useAppDispatch();
  const objectTypeFields = useSelector(
    appServiceRawObjectFields(appName, objectType.objectTypeExtId)
  );
  // action
  const onUpdateLabelForField = useCallback(
    (fieldLabel: any, fieldIdx: any) => {
      dispatch(
        updateObjectTypesMapping({
          appName,
          objectTypeIdx,
          fieldIdx,
          fieldLabel,
        })
      );
    },
    [appName, objectTypeIdx]
  );

  const onUpdateExtIdForField = useCallback(
    (fieldExtId: any, fieldIdx: any) => {
      dispatch(
        updateExtIdForFieldInObjectType({
          appName,
          objectTypeIdx,
          fieldIdx,
          fieldExtId,
        })
      );
    },
    [appName, objectTypeIdx]
  );

  const onUpdateLabelForObjectType = useCallback(
    (labelField: any) =>
      dispatch(updateForObjectType({ appName, objectTypeIdx, labelField })),
    [appName, objectTypeIdx]
  );

  const onUpdateSecondaryLabelForObjectType = useCallback(
    (secondaryLabelField: any) =>
      dispatch(
        updateForObjectType({ appName, objectTypeIdx, secondaryLabelField })
      ),
    [appName, objectTypeIdx]
  );

  return (
    <Table
      size="middle"
      columns={[
        {
          title: 'Field key',
          dataIndex: 'appFieldName',
          key: 'appFieldName',
        },
        {
          title: 'Label',
          dataIndex: 'fieldLabel',
          key: 'fieldLabel',
          render: (fieldLabel, record, fieldIdx) => (
            <Typography.Paragraph
              style={{ marginBottom: '0' }}
              editable={{
                onChange: (newLabel) =>
                  onUpdateLabelForField(newLabel, fieldIdx),
              }}
            >
              {fieldLabel}
            </Typography.Paragraph>
          ),
        },
        {
          title: 'Mapping',
          dataIndex: 'fieldExtId',
          key: 'fieldExtId',
          render: (fieldExtId, record, fieldIdx) => (
            <Select
              size="small"
              value={fieldExtId}
              onChange={(fieldExtId) =>
                onUpdateExtIdForField(fieldExtId, fieldIdx)
              }
              style={{ minWidth: '100%' }}
              showSearch
              allowClear
            >
              {objectTypeFields.map((el: IObjectTypeField) => (
                <Select.Option value={el.extid} key={el.extid}>
                  {el.extid}
                </Select.Option>
              ))}
            </Select>
          ),
        },
        {
          title: 'Label',
          dataIndex: 'appFieldName',
          key: 'label',
          render: (appFieldName) => (
            <Radio
              checked={appFieldName === objectType.labelField}
              onChange={() => onUpdateLabelForObjectType(appFieldName)}
            />
          ),
        },
        {
          title: 'Secondary label',
          dataIndex: 'appFieldName',
          key: 'secondaryLabel',
          render: (appFieldName) => (
            <Radio
              checked={appFieldName === objectType.secondaryLabelField}
              onChange={() => onUpdateSecondaryLabelForObjectType(appFieldName)}
            />
          ),
        },
      ]}
      dataSource={objectType?.fields?.filter((i: any) => i.isActive) || []}
      rowKey="appFieldName"
      pagination={false}
    />
  );
};

export default MappedFieldMapping;
